<template>
    <ais-current-refinements
        :included-attributes="['brand']"
        :transform-items="preloadBrands"
    >
        <template #default="{ items, createURL }">
            <div class="brand-description">
                <div class="columns" v-if="items && items[0]?.refinements?.length === 1">
                    <div v-if="brand.img" class="brand-logo">
                        <img :src="brand.img" :alt="brand.title">
                    </div>
                    <div v-else>
                        <h2 v-text="brand.title"></h2>
                    </div>
                    <hr>
                    <div v-html="brand.description" class="description"></div>
                </div>
            </div>
        </template>
    </ais-current-refinements>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import {mapActions} from 'vuex';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
    data: () => ({
        brand: {},
    }),
    methods: {
        preloadBrands(items) {
            items.forEach(({ refinements }) => refinements.forEach(refinement => {
                this.preloadBrandDetails(refinement.value)
            }))

            return items
        },
        preloadBrandDetails(name) {
            axios.get('/actions/anvil-module/anvil/brand-info', { params: { name } })
                .then(r => this.brand = r.data)
                .catch(r => this.brand = {})
        },
    },
}
</script>
